module.exports = __webpack_public_path__ + "img/coinmarketcap1.aff7d908.png";